import { render, staticRenderFns } from "./ModalIntrustCA.vue?vue&type=template&id=479f0c48&scoped=true"
import script from "./ModalIntrustCA.vue?vue&type=script&lang=js"
export * from "./ModalIntrustCA.vue?vue&type=script&lang=js"
import style0 from "./ModalIntrustCA.vue?vue&type=style&index=0&id=479f0c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479f0c48",
  null
  
)

export default component.exports